import { Injectable } from "@angular/core";
import {DateTime} from './date.model';


@Injectable()
export class CommonService{
    


    getDateTime(timestamp):DateTime{

        if(timestamp){
            var date:any = new Date(timestamp * 1000);
            var day = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();

            let hour:any = date.getHours();
            let minutes:any = date.getMinutes();
            let seconds:any = date.getSeconds(); 
            let miliSeconds = date.getTime();
            
           
            
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (date < 10) {
                date = "0" + date;
            }
    
          return new DateTime(day,month,year,hour,minutes,seconds,miliSeconds);
            

        }
        return null;

    }

    getDateArrayFromTimestamp(timestamp){
        dateArray = [];
        if(timestamp != undefined && timestamp != 0 && timestamp != null){
            var date:any = new Date(timestamp * 1000);
            var day = date.getDate();
            var month = date.getMonth();
            var year = date.getFullYear();

            let hour:any = date.getHours();
            let minutes:any = date.getMinutes();
           
           
            
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (date < 10) {
                date = "0" + date;
            }
    
            var dateArray = [];
            dateArray.push(day);
            dateArray.push(month);
            dateArray.push(year);
            dateArray.push(hour);
            dateArray.push(minutes);
            

        }
        return dateArray;
    }

     timestampToHM(timestamp) {
        let time:any = "N/A";
        if (timestamp != 0 && timestamp != undefined && timestamp != null) {

            time = new Date(timestamp * 1000);
            var minutes = time.getMinutes();
            var hours = time.getHours();
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }
            time = hours + ":" + minutes;
        }
        return time;
    }

     timestampToDate(timestamp, formater) {
        let date:any = "N/A";
        if (timestamp) {
            date = new Date(timestamp * 1000);
            var day = date.getDate();
            var month = date.getMonth();
            month = month + 1;
            if (day < 10) {
                day = "0" + day;
            }
            if (month < 10) {
                month = "0" + month;
            }
            if (formater != undefined) {
                date = day + formater + month + formater + date.getFullYear();
            } else {
                date = day + "/" + month + "/" + date.getFullYear();
            }

        }
        return date;
    }

     timeDiffDDHM(startTimestamp, endTimestamp) {
        var timeDiff = "N/A";
        var difference = endTimestamp - startTimestamp;
        let daysDifference:any = Math.floor(difference / 60 / 60 / 24);
        difference -= daysDifference * 60 * 60 * 24;

        let hours:any = Math.floor(difference / 60 / 60);
        difference -= hours * 60 * 60;

        let minutes:any = Math.floor(difference / 60);
        difference -= minutes * 60;
        if (minutes < 0) {
            minutes = 60 + minutes;
        }
        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (daysDifference < 10) {
            daysDifference = "0" + daysDifference;
        }
        var secondsDifference = Math.floor(difference);
        timeDiff = hours + ":" + minutes +' hrs';
        if (daysDifference > 0) {
            timeDiff = daysDifference + " day(s)";
        }
        return timeDiff;


    }

     nextDayTimestamp(timestamp) {
        var date = new Date(timestamp * 1000);
        date.setDate(date.getDate() + 1);
        return Math.round(date.getTime() / 1000);
    }


     prevDayTimestamp(timestamp) {
        var date = new Date(timestamp * 1000);
        date.setDate(date.getDate() - 1);
        return Math.round(date.getTime() / 1000);
    }

     timeDiffDDHMStr(timestamp) {
        var time = "N/A";
        if (!timestamp) {
            return time;
        }

        let currentTime:any = new Date();
        currentTime = Math.round(currentTime.getTime() / 1000);
        var diff = currentTime - timestamp;
        let daysDifference:any = Math
            .floor(diff / 60 / 60 / 24);
        diff -= daysDifference * 60 * 60 * 24;

        let hoursDifference:any = Math
            .floor(diff / 60 / 60);
        diff -= hoursDifference * 60 * 60;

        let minutesDifference:any = Math.floor(diff / 60);
        diff -= minutesDifference * 60;

        // var secondsDifference = Math.floor(diff);

        if (daysDifference > 0) {
            if (daysDifference < 10
                && daysDifference > 1) {
                // daysDifference = "0" + daysDifference;
                time = daysDifference
                    + " Days Ago";
            } else if (daysDifference === 1) {
                // daysDifference = "0" + daysDifference;
                time = daysDifference
                    + " Day Ago";
            } else {
                time = daysDifference
                    + " Days Ago";
            }
        } else if (hoursDifference > 0) {
            if (hoursDifference < 10
                && hoursDifference > 1) {
                // hoursDifference = "0" + hoursDifference;
                time = hoursDifference
                    + " Hours Ago";
            } else if (hoursDifference === 1) {
                // hoursDifference = "0" + hoursDifference;
                time = hoursDifference
                    + " Hour Ago";
            } else {
                time = hoursDifference
                    + " Hours Ago";
            }
        } else {
            if (minutesDifference < 0) {
                minutesDifference = 60 + minutesDifference;
            }
            if (minutesDifference < 10
                && minutesDifference > 1) {
                // minutesDifference = "0"
                //     + minutesDifference;
                time = minutesDifference
                    + " Minutes Ago";
            } else if (minutesDifference === 1) {
                // minutesDifference = "0"
                //     + minutesDifference;
                time = minutesDifference
                    + " Minute Ago";
            } else if(minutesDifference == 0){
                time =  " A Moment Ago";
            }else {
                time = minutesDifference
                    + " Minutes Ago";
            }
        }

        return time;
    }

     timeDDHMStr(timestamp) {
        var time = "NA";
        if(!timestamp){
            return time;
        }
        var actualDate = new Date(timestamp*1000);
        var actualTimestamp = timestamp;
        let yesterdayStartTimestamp:any = new Date();
        let todayTimestamp:any = parseInt((new Date().getTime() / 1000).toString());
        yesterdayStartTimestamp.setDate(new Date().getDate() - 1);
        yesterdayStartTimestamp.setHours(0, 0, 0, 0);
        yesterdayStartTimestamp = parseInt((yesterdayStartTimestamp.getTime() / 1000).toString());
        if (todayTimestamp - actualTimestamp < 86400) {
            time = this.timeDiffDDHMStr(actualTimestamp);
        } else if (actualTimestamp > yesterdayStartTimestamp) {
            let hour:any = actualDate.getHours();
            let minutes:any = actualDate.getMinutes();
            
            if (hour < 10) {
                hour = "0" + hour;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            time = "Yesterday at " + hour + ":" + minutes + " " ;
        } else {
         
                let hour:any = actualDate.getHours();
                let minutes:any = actualDate.getMinutes();
                let date:any = actualDate.getDate();
                var year = actualDate.getFullYear();

                var days = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
                var day = days[ actualDate.getDay() ];

                if (hour < 10) {
                    hour = "0" + hour;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (date < 10) {
                    date = "0" + date;
                }

                var month = new Array(12);
                month[0] = "Jan";
                month[1] = "Feb";
                month[2] = "Mar";
                month[3] = "Apr";
                month[4] = "May";
                month[5] = "Jun";
                month[6] = "Jul";
                month[7] = "Aug";
                month[8] = "Sep";
                month[9] = "Oct";
                month[10] = "Nov";
                month[11] = "Dec";

                var newmonth = month[actualDate.getMonth()];

                time = hour + ":" + minutes + " " + " " + date + " " + newmonth + " " + year + " " + day;
            
        }

        return time;

    }
    
     startDayTimestamp(timestamp){
        let time:any = "NA";
        if(!timestamp){
            return time;
        }
         var date = new Date(timestamp*1000);
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            time=Math.round(date.getTime()/1000);
            return time;
    }
    
     endDayTimestamp(timestamp){
        let time:any = "NA";
        if(!timestamp){
            return time;
        }
         var date = new Date(timestamp*1000);
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            time=Math.round(date.getTime()/1000);
            return time;
    }
    
     getInAddress(obj){
        var add = "Location Not Found";
        if (!obj.in_address) {
             if (obj.in_lat > 0 && obj.in_lon > 0) {
                add = obj.in_lat.toFixed(4) + "," + obj.in_lon.toFixed(4);
            }
        }else{
            add = obj.in_address;
        }
        
        return add;
    }
    
     getOutAddress(obj){
        var add = "Location Not Found";
        if (!obj.out_address) {
             if (obj.out_lat > 0 && obj.out_lon > 0) {
                add = obj.out_lat.toFixed(4) + "," + obj.out_lon.toFixed(4);
            }
        }else{
            add = obj.out_address;
        }
        
        return add;
    }
    
     timestampToDateHM(timestamp){
        var date = this.timestampToDate(timestamp,null);
        var time = this.timestampToHM(timestamp);
        var dateTime = date +" "+ time;
        return dateTime;
    }
    
     getDateToTimeStamp(date){
        var timestampValue:any = 0;
        if(date != null && date != '' && date != undefined){
            var dateTimeStrings = date.split(' ');
            
            var gtTweleve = false;
            var dateString = dateTimeStrings[0].split('/');
            var month = parseInt(dateString[1])-1;
            var timeString = dateTimeStrings[1].split(':');
            if(dateTimeStrings[2]=="PM"){
                gtTweleve = true;
            }
            
            var hours = timeString[0];
            
            if(gtTweleve && timeString[0]!=12){
                hours = parseInt(hours) + 12;
            }else if(!gtTweleve && timeString[0]==12){
                hours == 0;
            }
            
            timestampValue = new Date(dateString[2],month,dateString[0],hours,timeString[1],0,0);
            timestampValue = timestampValue.getTime() / 1000;
            return timestampValue;
        }
    }

    getHHMMSS(seconds){
        if (typeof(seconds) == 'undefined') {
            return "-";
        }
        if(seconds<0){
            seconds = 0;
        }
        var minutes = (Math.floor(seconds / 60)) % 60;
        var hours = Math.floor(seconds / 3600);
        var hh = '';
        var mm = '';
        var ss = ''
        if(hours<10){
            hh = "0"+hours;
        }else{
            hh = ""+hours;
        }
        if(minutes<10){
            mm="0"+minutes;
        }else{
            mm = ""+minutes;
        }
        var sss = seconds % 60;
        if(sss<10){
            ss = "0"+sss;
        }else{
            ss = ""+sss;
        }
            
        var time = hh + ":" + mm + ":" + ss;
        return time;
    }

    getDifferenceOfTwoTimestamp(startDate: any, endDate: any) {
        var date1: any = new Date(startDate * 1000);

        var date2: any = new Date(endDate * 1000);

        var res: any = Math.abs(date1 - date2) / 1000;

        // get total days between two dates
        var days = Math.floor((res+1) / 86400);

        // get hours        
        var hours = Math.floor(res / 3600) % 24;

        // get minutes
        var minutes = Math.floor(res / 60) % 60;

        // get seconds
        var seconds = res % 60;
        return days;
    }

    getHHMM(seconds){
        if (typeof(seconds) == 'undefined') {
            return "-";
        }
        if(seconds<0){
            seconds = 0;
        }
        var minutes = (Math.floor(seconds / 60)) % 60;
        var hours = Math.floor(seconds / 3600);
        var hh = '';
        var mm = '';
        if(hours<10){
            hh = "0"+hours;
        }else{
            hh = ""+hours;
        }
        if(minutes<10){
            mm="0"+minutes;
        }else{
            mm = ""+minutes;
        }
        
        var time = hh + ":" + mm;
        return time;
    }

    getSeconddsFromTimeString(timeStr) {
     
        if (timeStr && timeStr != "") {
      
            var timeArray = timeStr.split(":");
            var hour = Number(timeArray[0]);
            var min = Number(timeArray[1]);
            var sec = Number(timeArray[2]);
      
      
            var seconds = 0;
            seconds = hour * 3600 + min * 60 + sec;
            console.log(seconds)
            return Math.floor(seconds);
        }
      }
      getSeconddsFromTimeStringAMPM(timeStr) {
     
        if (timeStr && timeStr != "") {
            var timeStr1 = timeStr.split(" ");
           var seconds =  this.getSeconddsFromTimeString(timeStr1[0]);

           if(timeStr1[1]=='PM'){
               seconds = seconds + 3600*12;
           }
           return seconds ;
          
        }
      }

      secondsToHms(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        
            var hDisplay = h < 10? '0'+h : h;
            var mDisplay = m < 10? '0'+m : m;
            var sDisplay = s < 10? '0'+s : s;
            
            return hDisplay + ":" + mDisplay + ":" + sDisplay; 
        
    }
    secondsToHmsAMPM(d) {
        let e = d;
        if(d > 3600*12){
            e = d - 3600 * 12;
        }
        var secondsToHms = this.secondsToHms(e);
        if(d>12*3600){
            secondsToHms = secondsToHms + " PM";
        }else{
            secondsToHms = secondsToHms + " AM";
        }

            
        return secondsToHms; 
        
    }

    getHoursMinFromSeconds(d){
       
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
    
        var hDisplay = (h > 0 && h < 10) ? "0"+h : (h>=10) ? h:"00";
        var mDisplay = (m > 0 && m < 10) ? "0"+m : (m >= 10) ? m :"00";
        var sDisplay =(s > 0 && s < 10) ? "0"+s : (s >= 10) ? s :"00";
        return hDisplay+":"+mDisplay+":"+ sDisplay; 
    }


    validateEmail(data){
        var rgx = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (data.match(rgx)) {
         
        }
        else {
          data = "";  
        }
        return data;
      }

       secondsToDhms(seconds) {
        seconds = Number(seconds);
        var d = Math.floor(seconds / (3600*24));
        var h = Math.floor(seconds % (3600*24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);
        
        var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
        var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
        return dDisplay + hDisplay + mDisplay + sDisplay;
        }

        
        getPercentForDraw(count, totalCount) {
            if (totalCount > 0) {
                var percent = (count * 100) / totalCount | 0;
                percent = Math.round(percent / 10);
                return percent * 10;
            }
            return 0;
        }

        getPercentage(val, total){
            if(total>0){
                let percent = (val * 100)/total;
                return percent;
            }
            return 0;
        }


        decodePath(encoded) {
    		var pts = [];
    		var index = 0, len = encoded.length;
    		var lat = 0, lng = 0;
    		while (index < len) {
    		var b, shift = 0, result = 0;
    		do {
    		b = encoded.charAt(index++).charCodeAt(0) - 63;
    		result |= (b & 0x1f) << shift;
    		shift += 5;
    		} while (b >= 0x20);

    		var dlat = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
    		lat += dlat;
    		shift = 0;
    		result = 0;
    		do {
    		b = encoded.charAt(index++).charCodeAt(0) - 63;
    		result |= (b & 0x1f) << shift;
    		shift += 5;
    		} while (b >= 0x20);
    		var dlng = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
    		lng += dlng;
    		pts.push([lat / 1E6, lng / 1E6]);
    		}
    		return pts;
        }
        
        decodePath2(encoded) {
    		var pts = [];
    		var index = 0, len = encoded.length;
    		var lat = 0, lng = 0;
    		while (index < len) {
    		var b, shift = 0, result = 0;
    		do {
    		b = encoded.charAt(index++).charCodeAt(0) - 63;
    		result |= (b & 0x1f) << shift;
    		shift += 5;
    		} while (b >= 0x20);

    		var dlat = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
    		lat += dlat;
    		shift = 0;
    		result = 0;
    		do {
    		b = encoded.charAt(index++).charCodeAt(0) - 63;
    		result |= (b & 0x1f) << shift;
    		shift += 5;
    		} while (b >= 0x20);
    		var dlng = ((result & 1) != 0 ? ~(result >> 1) : (result >> 1));
    		lng += dlng;
    		pts.push([lat / 1E5, lng / 1E5]);
    		}
    		return pts;
        }
        
        nameSorting(getName) {
            if (getName) {
                if(getName.trim() == ""){
                    return "";
                }
                getName = getName.trim().toLowerCase().split(" ");
                var firstLetter = '';
                var firstLetterWord = '';
                if (getName.length > 1)
                    firstLetter = getName[0][0] + getName[getName.length - 1][0];
                else {
                    firstLetter = getName[0][0];
                }
                firstLetterWord = firstLetter.toUpperCase();
                return firstLetterWord;
            }
            return "";
        }
        timeStampToHHMMAMPM(timestamp) {
            var date =  new Date(timestamp * 1000);
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            var  h = hours < 10 ? '0'+hours : hours;
            var min = minutes < 10 ? '0'+minutes : minutes;
            var time = h + ':' + min + ' ' + ampm;
            return time;
          }

          timeStrToHHMMSSAMPM(timeStr) {
        	if(timeStr){
        		let hhmmssAm = timeStr.split(" ");
        		
        		let hhmmss = hhmmssAm[0];
        		let am = hhmmssAm[1];
        		
        		let hhmmssArr = hhmmss.split(":");
        		hhmmssArr.push(am);
        		
        		return hhmmssArr;
        	}
        	return null;
        }
        
        
}